import {
  postApiPesAccessTokenSaveLoginUser,
  postApiPesAccessTokenUserLogOut,
} from '@/services/pes/accessToken';
import { User } from 'oidc-client-ts';

const TOKEN_KEY = 'pes_token';
const SESSION_STATE_KEY = 'pes_session_state';
const isLogin = () => {
  return (
    !!localStorage.getItem(TOKEN_KEY) &&
    !!localStorage.getItem(SESSION_STATE_KEY)
  );
};
const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};
const getSessionState = () => {
  return localStorage.getItem(SESSION_STATE_KEY);
};
const setToken = async (user: User) => {
  const items = {
    [TOKEN_KEY]: user.access_token,
    [SESSION_STATE_KEY]: user.session_state ?? '',
  };
  Object.entries(items).forEach(([key, value]) =>
    localStorage.setItem(key, value),
  );

  const result = await postApiPesAccessTokenSaveLoginUser();
  if (result.success) {
  }
};
const clearToken = async () => {
  //调用后端接口，清除Redis中的缓存，同时将Idp中的改用户的session logout
  const result = await postApiPesAccessTokenUserLogOut();
  if (result.success)
    [TOKEN_KEY, SESSION_STATE_KEY].forEach((key) =>
      localStorage.removeItem(key),
    );
};
export { clearToken, getSessionState, getToken, isLogin, setToken };
